export function debounce<T extends Function>(func: T, delay = 300): T {
  let inDebounce: any;
  return ((...args: any) => {
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func(...args), delay);
  }) as any;
}
